import _ from 'lodash';
import { translate } from '../common/translate/translations';

export const computeSpecs = state => {
  var config = _.get(state, 'config');
  var techSpecs = _.get(config, 'technicalSpecifications');

  if (!techSpecs) {
    return [];
  }

  var country = _.get(state.params, 'country');

  // Loads a specific the max trailering disclosure based on if the Max Trailering package is selected or not
  var maxTraileringDisclosure;
  if (_.get(config.options, 'NHT') && config.options.NHT.selected) {
    maxTraileringDisclosure = translate('max.trailering.selected.disclosure');
  } else {
    maxTraileringDisclosure = translate('max.trailering.unselected.disclosure');
  }

  var filteredSpecs = techSpecs.filter(function(spec) {
    return !spec.type.match(/dimension|fuel economy/i);
  });

  var countrySuffix = country === 'CA' ? '-ca' : '';

  var towingSpecs = _.filter(filteredSpecs, { id: 33 }).map(function(spec) {
    var value = _.map(spec.units, 'formattedValue').join('/');
    var unit = '(' + _.map(spec.units, 'unit').join('/') + ')';

    return _.assign({}, spec, {
      value: value,
      unit: unit,
      imgSrc: 'tow' + countrySuffix,
      disclosure: _.template(maxTraileringDisclosure)({
        bodyStyle: _.get(state.appResources, 'bodyStyleTitle'),
        year: _.get(state.params, 'modelyear'),
        driveType: _.get(config.driveType, 'id'),
        config: _.get(config.bodyType, 'formattedConfig'),
        trim: _.get(config.style.vehicleInfo, 'name'),
        engine: _.get(config.engine, 'shortCFD')
      })
    });
  });

  var otherSpecs = filteredSpecs
    .filter(function(spec) {
      return spec.id !== 33;
    })
    .map(function(spec) {
      return _.assign({}, spec, {
        imgSrc: spec.imgSrc
          ? spec.imgSrc
              .replace(/\..+$/, '')
              .replace(/_/g, '-')
              .toLowerCase() + countrySuffix
          : ''
      });
    });

  var fuelSpecs = _.filter(techSpecs, { type: 'Fuel Economy' });
  var combinedFuel = _.map(fuelSpecs, 'value').join('/');
  var normalizedFuelSpec = _.filter(fuelSpecs, { id: 26 }).map(function(spec) {
    return _.assign({}, spec, {
      value: combinedFuel,
      name: translate('epa.fuel.label'),
      imgSrc: (spec.imgSrc || '')
        .replace(/\..+$/, '')
        .replace(/_/g, '-')
        .toLowerCase(),
      disclosure:
        country === 'CA' ? translate('fuel.efficiency.disclosure') : ''
    });
  });

  return towingSpecs.concat(otherSpecs, normalizedFuelSpec);
};
